import { render } from "./ProfileStartMfa.vue?vue&type=template&id=4e82d642"
import script from "./ProfileStartMfa.vue?vue&type=script&lang=js"
export * from "./ProfileStartMfa.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/pescle-rodent/pescle-rodent/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__